var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"character-count"},[_vm._v(" "+_vm._s(_vm.remainingCharacterCount)+" "+_vm._s(_vm.remainingCharacterCount && _vm.remainingWordCount ? ' or ' : '')+_vm._s(_vm.remainingWordCount)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }